const SUPPORT_EMAIL_TO_RECEIVE_PRODUCT_FEEDBACK = "support@ecminsights.com";
const SUPPORT_EMAIL_TO_RECEIVE_SUPPORT_REQUESTS = "support@ecminsights.com";
const SUPPORT_EMAIL_TO_RECEIVE_SETUP_REQUESTS = "support@ecminsights.com";

export { SUPPORT_EMAIL_TO_RECEIVE_PRODUCT_FEEDBACK, SUPPORT_EMAIL_TO_RECEIVE_SUPPORT_REQUESTS, SUPPORT_EMAIL_TO_RECEIVE_SETUP_REQUESTS };